/* eslint-disable camelcase */
import elementIntersectionObserver from '../../../dom/elementintersectionobserver';
import { spSelectItem, spViewItemList } from './plpevents';


export function captureItemSelection() {
    const $list = document.querySelector('[data-item-category-parent]');

    $list.addEventListener('click', e => {
        const $parent = e.target.closest('[data-item-id]');

        if ($parent && !/input|label|svg/gi.test(e.target.nodeName)) {
            spSelectItem({
                ...$list.dataset,
                ...$parent.dataset
            });
        }
    });
}


export function monitorPLPItemsInView() {
    let scrollListener;
    let observers = [];

    const itemMap = new Map();
    const whenInView = elementIntersectionObserver({ rootMargin: '0px', threshold: 0.5 });

    const inView = items => {
        if (!items || !items.length) {
            return;
        }

        spViewItemList(items);
    };

    const process = () => {
        itemMap.clear();

        if (observers.length) {
            observers.forEach(observer => observer.disconnect());
            observers = [];
        }

        if (scrollListener) {
            scrollListener.dispose();
        }

        const $list = document.querySelector('[data-item-category-parent]');
        const $listItems = Array.from($list.querySelectorAll('[data-item-id]'));

        for (const $item of $listItems) {
            if (isElement50PercentInViewport($item)) {
                itemMap.set($item, {
                    ...$item.dataset,
                    ...$list.dataset
                });
                continue;
            }
            break;
        }

        inView([...itemMap.values()]);

        $listItems
            .filter($item => !itemMap.has($item))
            .forEach($item => {
                observers.push(whenInView($item, () => {
                    itemMap.set($item, {
                        ...$item.dataset,
                        ...$list.dataset
                    });
                }));
            });

        itemMap.clear();

        scrollListener = scrollStopEventListener(() => {
            inView([...itemMap.values()]);
            itemMap.clear();
        });
    };

    return {
        refresh: () => process()
    };
}

function scrollStopEventListener(onScrollStop) {
    if (typeof onScrollStop !== 'function') {
        throw new Error('scrollStopEventListener requires a callback function');
    }

    let timer;

    const onScroll = () => {
        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => onScrollStop(), 500);
    };

    window.addEventListener('scroll', onScroll);

    return {
        dispose: () => {
            if (timer) {
                clearTimeout(timer);
            }

            window.removeEventListener('scroll', onScroll);
        }
    };
}

function isElement50PercentInViewport(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = (window.innerHeight || document.documentElement.clientHeight);

    return (
        (rect.top >= 0)
        && ((rect.top + (rect.height / 2)) <= windowHeight)
    );
}
